import { z } from 'zod'
import { VERSION_ASSET_PATH } from '../../version-asset'

const VersionAsset = z.object({ buildId: z.string().trim().min(1) })

const globalFetch: typeof fetch = (input, init) => fetch(input, init)

export const fetchDeployedBuildId = async (
  signal: AbortSignal,
  fetchImpl: typeof fetch = globalFetch,
): Promise<string | null> => {
  const response = await fetchImpl(VERSION_ASSET_PATH, { cache: 'no-store', signal }).catch(() => null)
  if (response === null || !response.ok) return null
  const parsed = VersionAsset.safeParse(await response.json().catch(() => null))
  return parsed.success ? parsed.data.buildId : null
}
